/* RMH · Mad Honey Advertorial (LP2) — advertorial-only behaviour.
 * Scroll reveal (.ce-reveal) is handled by rmh-ce.js, also loaded by the
 * advertorial header; this file adds only what LP2 needs on top:
 *   1) Reading-progress bar (fixed top, fills with scroll depth)
 *   2) Header transparent -> solid once scrolled past the hero
 *   3) Lab-report lightbox (open from triggers, keyboard-closable, focus-safe)
 * All effects honour prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1) Reading progress bar ------------------------------------- */
  function initProgress() {
    var fill = document.querySelector('[data-adv-progress]');
    if (!fill) return;
    var ticking = false;

    function set() {
      var doc = document.documentElement;
      var max = (doc.scrollHeight - doc.clientHeight) || 1;
      var pct = Math.min(1, Math.max(0, (window.scrollY || doc.scrollTop) / max));
      fill.style.width = (pct * 100) + '%';
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(set);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    set();
  }

  /* ---- 2) Header transparent -> solid ------------------------------ */
  function initHeader() {
    var header = document.querySelector('[data-adv-header]');
    if (!header) return;

    // Prefer toggling at the hero's bottom edge; fall back to a fixed offset.
    var hero = document.querySelector('.rmh-adv-hero');
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        header.classList.toggle('is-solid', !entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: '-58px 0px 0px 0px' }).observe(hero);
    } else {
      var onScroll = function () {
        header.classList.toggle('is-solid', (window.scrollY || 0) > 64);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---- 3) Lab-report lightbox -------------------------------------- */
  function initLightbox() {
    var box = document.querySelector('[data-adv-lightbox]');
    if (!box) return;
    var triggers = document.querySelectorAll('[data-adv-lightbox-open]');
    if (!triggers.length) return;

    var closeEls = box.querySelectorAll('[data-adv-lightbox-close]');
    var lastFocus = null;

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = box.querySelector('[data-adv-lightbox-close]');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(ev) {
      if (ev.key === 'Escape' || ev.keyCode === 27) close();
    }

    for (var i = 0; i < triggers.length; i++) triggers[i].addEventListener('click', open);
    for (var j = 0; j < closeEls.length; j++) closeEls[j].addEventListener('click', close);
    // Click on backdrop (the element itself, not the dialog) closes.
    box.addEventListener('click', function (ev) {
      if (ev.target === box) close();
    });
  }

  function init() {
    initProgress();
    initHeader();
    initLightbox();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
